import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

export class BidInsulationBus extends BaseBus{
    constructor(busObj: BidInsulationBus) {
        super(busObj);

    }
    CID(): any {
        return this.insulationId ;
    }
    setId(id: any) {
        this.insulationId  = id;
    }
    initialize(data: BidInsulationBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
       //this.bidSheetDetailId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidInsulationBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    insulationId : string;
   sizeId:string;
   thicknessId:string;
    thickness : number;
    unitCost : number;
    inventoryId:string;
    number:string;
    color:string;
    thickValue:number;
    sizeValue:number;
    inventoryNumber:string;
    insertDt : Date;
    insertUserId : string;
    updateDt : Date;
    updateUserId :string;
    mappingId : string;
}
